import React, { useState } from 'react'
import './sidebar.css'
 
import { MdDashboard } from 'react-icons/md'
import { FaUser, FaUsers } from 'react-icons/fa'
import { PiStudentFill } from 'react-icons/pi'
import { FaLocationDot } from 'react-icons/fa6'
import { GiDeadEye, GiOfficeChair } from 'react-icons/gi'
import { TbNotes } from 'react-icons/tb'
import { RiUserSettingsFill } from 'react-icons/ri'
import { useLocation, useNavigate } from 'react-router-dom'
 
import { AiFillTool } from 'react-icons/ai'
import { useToggle } from '../context/ToggleContext'

const SideBar = () => {

   const { isActive, toggleState } = useToggle()
  const navigate = useNavigate()
  const location = useLocation();
  const isActiveLink = (link) => link === location.pathname;

  const routCall = (el) => {
    navigate(el)
  }



  return (


    <div class='sidebar'>
      
      <div class='sideBarShow mt-3 col-11 m-auto position-sticky ' style={isActive ? { width: '300px' } : { width: '50px' }}>
          <div class='p-1'></div>
        <div class='d-flex align-items-center gap-3 col-11 m-auto  ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/')}>
          <div class='sliderIcon' style={isActiveLink('/') ? { background: 'white', color: "#034da2" } : {}}>
            <MdDashboard />
          </div>
          <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/') ? { fontWeight: '700' } : {}}  >Dashboard</p>
        </div>

        <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

        <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/members')}>
          <div class='sliderIcon' style={isActiveLink('/members') ? { background: 'white', color: "#034da2" } : {}}>
            <FaUsers />
          </div>
          <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/members') ? { fontWeight: '700' } : {}}  >Members</p>
        </div>

        <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

        <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} data-bs-toggle="collapse" href="#masterCollapse" role="button" aria-expanded="false" aria-controls="masterCollapse">
          <div class='sliderIcon' style={location.pathname.split('-')[0].replace('/', '') == "masters" ? { background: 'white', color: "#034da2" } : {}}>
            <AiFillTool />
          </div>
          <p class={`sliderText ${isActive ? 'active' : ''}`} style={location.pathname.split('-')[0].replace('/', '') == "masters" ? { fontWeight: '700' } : {}}  >Masters <i class="bi bi-caret-down-fill"></i></p>
        </div>

        <div class="collapse mt-2" id="masterCollapse">
          <div class="py-3" style={{ background: 'rgba(255,255,255,0.2)' }}>
            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/masters-education-occupation')}>
              <div class='sliderIcon' style={isActiveLink('/masters-education-occupation') ? { background: 'white', color: "#034da2" } : {}}>
                <PiStudentFill />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters-education-occupation') ? { fontWeight: '700' } : {}}  >Education/Occupation</p>
            </div>

            <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/masters-location')}>
              <div class='sliderIcon' style={isActiveLink('/masters-location') ? { background: 'white', color: "#034da2" } : {}}>
                <FaLocationDot />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters-location') ? { fontWeight: '700' } : {}}  >Location</p>
            </div>

            <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/masters-skills')}>
              <div class='sliderIcon' style={isActiveLink('/masters-skills') ? { background: 'white', color: "#034da2" } : {}}>
                <GiDeadEye />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters-skills') ? { fontWeight: '700' } : {}}  >Skills</p>
            </div>

            <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/masters-designation')}>
              <div class='sliderIcon' style={isActiveLink('/masters-designation') ? { background: 'white', color: "#034da2" } : {}}>
                <GiOfficeChair />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters-designation') ? { fontWeight: '700' } : {}}  >Designation</p>
            </div>

          </div>
        </div>

        {/* <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/masters')} >
          <div class='sliderIcon' style={isActiveLink('/masters') ? { background: 'white', color: "#034da2" } : {}}>
            <AiFillTool />
          </div>
          <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters') ? { fontWeight: '700' } : {}}   >Masters</p>
        </div> */}





        <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

        <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} data-bs-toggle="collapse" href="#reportsCollapse" role="button" aria-expanded="false" aria-controls="reportsCollapse">
          <div class='sliderIcon' style={location.pathname.split('-')[0].replace('/', '') == "reports" ? { background: 'white', color: "#034da2" } : {}}>
            <TbNotes />
          </div>
          <p class={`sliderText ${isActive ? 'active' : ''}`} style={location.pathname.split('-')[0].replace('/', '') == "reports" ? { fontWeight: '700' } : {}}  >Reports <i class="bi bi-caret-down-fill"></i></p>
        </div>
        <div class="collapse mt-2" id="reportsCollapse">
          <div class="py-3" style={{ background: 'rgba(255,255,255,0.2)' }}>
            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/reports-education-occupation')}>
              <div class='sliderIcon' style={isActiveLink('/reports-education-occupation') ? { background: 'white', color: "#034da2" } : {}}>
                <PiStudentFill />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/reports-education-occupation') ? { fontWeight: '700' } : {}}  >Education/Occupation</p>
            </div>

          </div>
        </div>
{/* 
        <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/reports')} >
          <div class='sliderIcon' style={isActiveLink('/reports') ? { background: 'white', color: "#034da2" } : {}}>
            <TbNotes />
          </div>
          <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/reports') ? { fontWeight: '700' } : {}}   >Masters</p>
        </div> */}

        <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />


        <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/users')}>
          <div class='sliderIcon' style={isActiveLink('/users') ? { background: 'white', color: "#034da2" } : {}}>
            <FaUser />
          </div>
          <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/users') ? { fontWeight: '700' } : {}}  >Users</p>
        </div>

        <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />


        <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routCall('/role')}>
          <div class='sliderIcon' style={isActiveLink('/role') ? { background: 'white', color: "#034da2" } : {}}>
            <RiUserSettingsFill />
          </div>
          <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/role') ? { fontWeight: '700' } : {}}  >Role</p>
        </div>


      </div>

    </div>

  )
}

export default SideBar